import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LoginService } from '../../login/login.service';
import { NotificationService } from '../notification.service';
import { isEqualTo } from '../form-validators/field-equals.validator';

@Component({
  selector: 'app-dialog-changepwd',
  templateUrl: 'dialog-changepwd.component.html',
})
export class DialogChangePwdComponent {
  public form: FormGroup;
  public isSaving = false;

  constructor(
    public dialogRef: MatDialogRef<DialogChangePwdComponent>,
    private fb: FormBuilder,
    private loginService: LoginService,
    private notification: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.buildForm();
  }

  onChange(): void {
    this.isSaving = true;
    this.loginService
      .changePwd(this.form.value.actualPwd, this.form.value.newPwd)
      .then(() => {
        this.notification.success('Contraseña modificada correctamente');
        this.dialogRef.close();
      })
      .catch((reason) => {
        this.notification.error('No se pudo cambiar la contraseña, comprueba que su contraseña actual sea correcta');
        console.error(reason);
      })
      .finally(() => (this.isSaving = false));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * crear el formulario
   */
  private buildForm() {
    const pwdFormField = new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)]));
    const confirmPwdFormField = new FormControl('', isEqualTo(pwdFormField));

    this.form = this.fb.group({
      actualPwd: ['', Validators.compose([Validators.required])],
      newPwd: pwdFormField,
      newRepeatedPwd: confirmPwdFormField,
    });
  }
}
